// Values must match DocumentStatusDto.id (backend documentProcessStatus codes), not MIPS's own
// "no" code - project 667's catalogue is doc_process_status_id 1/2/3 = Redline/ForInfo/NoChange,
// with "no" 1/5/9 respectively; using "no" here mismatched for ForInfo/NoChange.
export enum DocumentProcessStatusCode {
  RedlineMarkup = 1,
  ForInfo = 2,
  NoChange = 3,
}

// Translation key for each status code's name - used only as a parenthetical translation next to
// the raw MIPS status name (e.g. in the status dialog), never as the primary label.
export const DOCUMENT_PROCESS_STATUS_LABEL_KEYS: Record<number, string> = {
  [DocumentProcessStatusCode.RedlineMarkup]: 'workOrderDocuments.status.redlineMarkup',
  [DocumentProcessStatusCode.ForInfo]: 'workOrderDocuments.status.forInfo',
  [DocumentProcessStatusCode.NoChange]: 'workOrderDocuments.status.noChange',
};

// "Status: {{id}} ({{name}})" - id/name are the raw MIPS code/name, left untranslated.
export const DOCUMENT_PROCESS_STATUS_LABEL_KEY = 'workOrderDocuments.status.label';
export const DOCUMENT_PROCESS_STATUS_NOT_SET_LABEL_KEY = 'workOrderDocuments.status.notSetLabel';
